import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Header, Content } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "./App.css";
import "styles/colors.css";

// Background
import Background from "components/base/Background";

// Header
import SiteHeader from "components/Header/SiteHeader";

// Routes
import RoutesComponent from "routes/Routes";


const App: React.FC = () => {
	return (
		<Router>
			<Background>
				{/* Top Header */}
				<SiteHeader />
				{/* Main Content */}
				<Content>
					<div style={{ maxWidth: 1400, padding: "2rem 1rem", margin: "0 auto" }}>
						<RoutesComponent />
					</div>
				</Content>
			</Background>
		</Router>
	);
};

export default App;
